import { createFlyerDetailPageState } from "../types/flyer-detail-page-state/flyer-detail-page-state.functions";
import { FlyerDetailPageState } from "../types/flyer-detail-page-state/flyer-detail-page-state.interface";
import { FlyerDetailPageActions, FlyerDetailPageActionType } from "./flyer-detail-page.actions";
import { FlyerDetailPageFormPositionActionType } from "../features/flyer-detail-page-form-position/store/flyer-detail-page-form-position.actions";
import { flyerDetailPageFormPositionReducer } from "../features/flyer-detail-page-form-position/store/flyer-detail-page-form-position.reducer";
import { flyerDetailPageFormPageReducer } from "../features/flyer-detail-page-form-page/store/flyer-detail-page-form-page.reducer";
import {
  FlyerDetailPageFormPageActions,
  FlyerDetailPageFormPageActionType,
} from "../features/flyer-detail-page-form-page/store/flyer-detail-page-form-page.actions";
import { flyerDetailPageAssetsReducer } from "../features/flyer-detail-page-assets/store/flyer-detail-page-assets.reducer";
import { FlyerDetailPageAssetsActionType } from "../features/flyer-detail-page-assets/store/flyer-detail-page-assets.actions";

export function flyerDetailPageReducer(
  state = createFlyerDetailPageState(),
  action: FlyerDetailPageActionType
): FlyerDetailPageState {
  switch (action.type) {
    case FlyerDetailPageActions.FetchPagePreview:
    case FlyerDetailPageActions.CreatePagePosition:
    case FlyerDetailPageActions.FetchPageTemplate:
      return {
        ...state,
        isLoading: true,
      };
    case FlyerDetailPageActions.CreatePagePositionSuccess:
      return {
        ...state,
        isLoading: false,
        editingType: "position",
        editPagePositionId: action.payload.id,
      };
    case FlyerDetailPageActions.FetchPagePreviewSuccess:
      return {
        ...state,
        isLoading: false,
        pagePreview: action.payload,
      };
    case FlyerDetailPageActions.SetEditPagePositionId:
      return {
        ...state,
        editingType: "position",
        editPagePositionId: action.payload,
      };
    case FlyerDetailPageActions.FetchPageTemplateSuccess:
      return {
        ...state,
        isLoading: false,
        template: action.payload,
      };
    case FlyerDetailPageActions.FetchPageTemplateFailure:
    case FlyerDetailPageActions.FetchPagePreviewFailure:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    case FlyerDetailPageActions.SelectLanguage:
      return {
        ...state,
        selectedLanguage: action.payload,
      };
    case FlyerDetailPageActions.DeSelectPosition:
      return {
        ...state,
        editPagePositionId: null,
      };
    case FlyerDetailPageActions.SetEditType:
      return {
        ...state,
        editingType: action.payload,
      };
    case FlyerDetailPageActions.ResetEditType:
      return {
        ...state,
        editingType: "none",
      };
    case FlyerDetailPageFormPageActions.Reset:
      return createFlyerDetailPageState();
    default:
      return {
        ...state,
        flyerDetailPageAssetsState: flyerDetailPageAssetsReducer(
          state.flyerDetailPageAssetsState,
          action as FlyerDetailPageAssetsActionType
        ),
        flyerDetailPageFormPageState: flyerDetailPageFormPageReducer(
          state.flyerDetailPageFormPageState,
          action as FlyerDetailPageFormPageActionType
        ),
        flyerDetailPageFormPositionState: flyerDetailPageFormPositionReducer(
          state.flyerDetailPageFormPositionState,
          action as FlyerDetailPageFormPositionActionType
        ),
      };
  }
}
